import { createSelector } from 'reselect';
import _ from 'lodash';
import { ATTRS_LABEL } from '@laigu/constants';

const genderSelect = [
  { label: '男', value: 'M' },
  { label: '女', value: 'F' }
];
const deletedKeyList = ['created_on', 'updated_on', 'latest_conv_on', 'latest_visit_on', 'tag', 'phone_result'];

export const makeGetCustomerFieldOrderByCategory = () =>
  createSelector([attrSetting => attrSetting], attrSetting => {
    const dataAttrSettingShow = [];
    attrSetting.forEach(item => {
      // 要去掉tag,latest_visit_on等时间
      if (!deletedKeyList.includes(item.name)) {
        dataAttrSettingShow.push(item);
      }
    });
    dataAttrSettingShow.sort((a, b) => a.rank - b.rank);
    const data = [...dataAttrSettingShow];
    const parseData = value => {
      const { metainfo } = value;
      const commonVal = {
        value: value.name,
        label: ATTRS_LABEL[value.name] || value.name
      };

      // 性别做特殊处理
      if (value.name === 'gender') {
        return {
          ...value,
          ...commonVal,
          type: 'radio',
          metainfo: genderSelect.map(val => ({ name: val.label, value: val.value }))
        };
      }
      // 处理metainfo
      if (metainfo && _.isArray(metainfo) && metainfo.length) {
        return {
          ...value,
          ...commonVal,
          metainfo: (metainfo && metainfo.map(val => ({ value: val, name: val }))) || []
        };
      }
      return { ...value, ...commonVal };
    };

    let main = [];
    let custom = [];
    let all = [];

    data.forEach(val => {
      const parsedData = parseData(val);
      if (val.category === 'main') {
        main.push(parsedData);
      }
      if (val.category === 'custom') {
        custom.push(parsedData);
      }
      all.push(parsedData);
    });
    return {
      main,
      custom,
      all
    };
  });

export const makeGetCustomerField = () =>
  createSelector([attrSetting => attrSetting], attrSetting => {
    const dataAttrSettingShow = [];
    attrSetting.forEach(item => {
      // 要去掉tag,latest_visit_on等时间
      if (item.display && !deletedKeyList.includes(item.name)) {
        dataAttrSettingShow.push(item);
      }
    });
    dataAttrSettingShow.sort((a, b) => a.rank - b.rank);
    const data = [...dataAttrSettingShow];
    return _.map(data, value => {
      const { metainfo } = value;
      // * label 的显示顺序  本地的自定义字段  > 远端的display_name > 远端的name
      const commonVal = {
        value: value.name,
        label: ATTRS_LABEL[value.name] || value.display_name || value.name
      };

      // 性别做特殊处理
      if (value.name === 'gender') {
        return {
          ...value,
          ...commonVal,
          type: 'radio',
          metainfo: genderSelect.map(val => ({ name: val.label, value: val.value }))
        };
      }
      // 处理metainfo
      if (metainfo && _.isArray(metainfo) && metainfo.length) {
        return {
          ...value,
          ...commonVal,
          metainfo: (metainfo && metainfo.map(val => ({ value: val, name: val }))) || []
        };
      }
      return { ...value, ...commonVal };
    });
  });
